import { ComponentProps } from 'react'
import { makeStyles } from '@material-ui/core'

import { joinStyles } from 'app/utils/theme'

const useStyles = makeStyles({
    root: {
        display: 'grid',
    },
})

type GridProperties = ComponentProps<'div'>

export const Grid = ({
    className,
    ...properties
}: Readonly<GridProperties>): JSX.Element => {
    const classes = useStyles()

    return (
        <div
            className={joinStyles(classes.root, className)}
            {...properties}
        />
    )
}
